module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/schedule.162b23e4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/schedule.png
// module id = 3067
// module chunks = 11